<script setup lang="ts">
import ExportDetectionButton from '@/components/Buttons/ExportDetectionButton.vue'
import { type EventDetailProvider, EHubProvider } from '@/types/enum/HubProviderEnum'
import type { EventModel } from '@/types/models/EventModel'
import {
    ExportDetectionButton as RFCExportDetectionButton,
    StackLayout
} from '@rfc/rfc-components-library'
import { inject, ref } from 'vue'
import EventAddGuntimeAction from './EventAddGuntimeAction.vue'
import EventReinitializeDevicesFiltersAction from './EventReinitializeDevicesFiltersAction.vue'
import EventSetFilterAction from './EventSetFilterAction.vue'

type Props = {
    data: EventModel
}
defineProps<Props>()

type Emits = {
    (e: 'refresh'): void
}
defineEmits<Emits>()

const { devices } = inject<EventDetailProvider>(EHubProvider.EVENT_DEVICES, {
    devices: ref([])
})
</script>

<template>
    <StackLayout :gap="8" direction="column" class="section-box px-7 py-4">
        <RFCExportDetectionButton :event="data" class="w-full">
            <template v-slot="templateProps">
                <ExportDetectionButton
                    v-if="data.id"
                    v-bind="templateProps"
                    :event="data"
                    hideEventSelector
                    :change="templateProps.change" />
            </template>
        </RFCExportDetectionButton>
        <EventSetFilterAction :data="data" />
        <EventReinitializeDevicesFiltersAction v-if="!!devices?.length" :data="data" />
        <EventAddGuntimeAction :data="data" @refresh="$emit('refresh')" />
    </StackLayout>
</template>
